if (!customElements.get('help-modal')) {
  customElements.define('help-modal', class HelpModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="HelpModal-"]');
    }

    hide() {
      // オプション選択モーダルの画面ロック解除を元に戻す
      if (this.openedBy) {
        const parentModal = this.openedBy.closest('[id*=select-option-modal__overlay]').parentNode.parentNode;
        if (parentModal) {
          bodyScrollLock.disableBodyScroll(parentModal);
        }
      }

      this.querySelector("#help-modal__body").innerHTML = "";
      super.hide();
    }

    show(opener, settings = null) {
      // オプション選択モーダルの画面ロック解除
      bodyScrollLock.clearAllBodyScrollLocks();

      super.show(opener);

      if (!settings && opener.dataset.modalSettings) {
        settings = JSON.parse(opener.dataset.modalSettings);
      }

      for (const img_url of settings) {
        const img = document.createElement('img');
        img.src = img_url;
        this.querySelector("#help-modal__body").append(img);
      }
    }

    createElementAndInnerHtml(tag, html) {
      let elem = document.createElement(tag);
      elem.innerHTML = html;
      return elem;
    }
  });
}